export enum RxFormCompletionLevel {
	Incomplete = 0,
	ReadyForScan = 1,
	ReadyForSend = 2
}